import type { AsyncThunkApiConfig } from '@/store'

import { createAsyncThunk } from '@reduxjs/toolkit'
import { RejectError } from '../../typings'

type Payload = {
  dates: string[]
  config: {
    format: 'XLSX' | 'CSV' | 'PDF'
    includePod?: boolean
    currentRoutes?: boolean
    includeBarcodes?: boolean
  }
}

/**
 * Export routes in different formats
 *
 * @private
 */
export const bulkExportRoutes = createAsyncThunk<
  // Return type of the payload creator
  string | null,
  // First argument to the payload creator
  Payload,
  // thunk API
  AsyncThunkApiConfig<RejectError>
>('domain/route/bulkExport', async (payload, thunkApi) => {
  try {
    const rpc = thunkApi.extra.domainProxy.getRpc()

    const response = await rpc('rpc/route/bulkExportArchived', {
      category: 'rpc',
      type: 'rpc/route/bulkExportArchived',
      payload,
    })

    if (response.type === 'rpc-failure') {
      return thunkApi.rejectWithValue({
        type: 'rpcFailure',
        message: response.errorMessage,
        error: response,
      })
    }

    // Download the attachment
    if (typeof response.result === 'string') {
      window.open(response.result)
    }

    return response.result
  } catch (error) {
    thunkApi.extra.journal.main(
      `Unknown error on {exportRoutes}`,
      { tags: ['rpc', 'order'], info: { payload, error } },
      'error',
    )

    return thunkApi.rejectWithValue({
      type: 'unknown',
      message: `Bulk export routes [${payload.dates.join(', ')}] failed`,
      error,
    })
  }
})
